import { render, staticRenderFns } from "./RunDetailTemplate.vue?vue&type=template&id=27628648&scoped=true&"
import script from "./RunDetailTemplate.vue?vue&type=script&lang=js&"
export * from "./RunDetailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27628648",
  null
  
)

export default component.exports